export function sourceItemToExtendedSourceItem(entry, alternativeBaseURL) {
    let baseURL = entry.baseURL || alternativeBaseURL;
    if (!baseURL) {
        if (!globalThis.location?.href) {
            throw new Error(`We could not find a baseURL for ${entry.relativePath}`);
        }
        else {
            baseURL = globalThis.location.href;
        }
    }
    const fileURL = new URL(entry.relativePath, baseURL);
    const source = {
        uuid: crypto.randomUUID(),
        name: entry.relativePath.split('/').pop() || '',
        size: entry.size,
        baseURL,
        relativePath: entry.relativePath,
        lastModified: entry.lastModified,
        text: async () => {
            const response = await fetch(fileURL.toString());
            return response.text();
        },
        arrayBuffer: async () => {
            const response = await fetch(fileURL.toString());
            return response.arrayBuffer();
        },
        // @ts-expect-error Should contain stream
        stream: async () => {
            const response = await fetch(fileURL.toString());
            //@ts-expect-error Should contain stream
            return response.stream();
        },
    };
    return source;
}
//# sourceMappingURL=sourceItemToExtendedSourceItem.js.map